/* global automatewooReferralsLocalizeScript, Cookies */
jQuery( document ).ready( function ( $ ) {
	const options = automatewooReferralsLocalizeScript;
	const shareFormI18n = options.share_form || {};

	function openBox( url ) {
		window.open(
			url,
			'automatewoo_social_share',
			'titlebar=no,toolbar=no,height=300,width=550,resizable=yes,status=no'
		);
	}

	$( 'a.js-automatewoo-open-share-box' ).on( 'click', function ( e ) {
		e.preventDefault();
		openBox( $( this ).attr( 'href' ) );
	} );

	if ( options.is_link_based ) {
		// save advocate key from url as cookie

		function getQueryVars() {
			const vars = [];
			const hashes = window.location.href
				.slice( window.location.href.indexOf( '?' ) + 1 )
				.split( '&' );
			for ( let i = 0; i < hashes.length; i++ ) {
				const hash = hashes[ i ].split( '=' );
				vars.push( hash[ 0 ] );

				const key = typeof hash[ 1 ] === 'undefined' ? 0 : 1;

				// Remove fragment identifiers
				const n = hash[ key ].indexOf( '#' );
				hash[ key ] = hash[ key ].substring(
					0,
					n !== -1 ? n : hash[ key ].length
				);
				vars[ hash[ 0 ] ] = hash[ key ];
			}
			return vars;
		}

		const ref = getQueryVars()[ options.link_param ];

		if ( typeof ref !== 'undefined' ) {
			Cookies.set( 'aw_referral_key', ref, {
				expires: parseInt( options.cookie_expires, 10 ),
				path: '/',
			} );
		}
	}

	/**
	 * Client-side mirror of WordPress is_email() (wp-includes/formatting.php).
	 * Catches common invalid shapes before submit; the server remains authoritative.
	 *
	 * @param {string} value Email address to validate.
	 * @return {boolean} Whether the value matches is_email()'s structural rules.
	 */
	function isValidEmail( value ) {
		if ( typeof value !== 'string' || value.length < 6 ) {
			return false;
		}

		// Require an @ after the first character (same as is_email).
		const atPos = value.indexOf( '@', 1 );

		if ( atPos === -1 ) {
			return false;
		}

		const local = value.slice( 0, atPos );

		// Local part: allowed character set from is_email().
		if ( ! /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+$/.test( local ) ) {
			return false;
		}

		const domain = value.slice( atPos + 1 );

		// Domain: no consecutive periods; no leading/trailing period or whitespace.
		if (
			/\.{2,}/.test( domain ) ||
			/^[.\s]/.test( domain ) ||
			/[.\s]$/.test( domain )
		) {
			return false;
		}

		const subs = domain.split( '.' );

		if ( subs.length < 2 ) {
			return false;
		}

		for ( let i = 0; i < subs.length; i++ ) {
			const sub = subs[ i ];

			// No leading/trailing hyphen; alphanumeric + hyphen only.
			if (
				/^-/.test( sub ) ||
				/-$/.test( sub ) ||
				! /^[a-z0-9-]+$/i.test( sub )
			) {
				return false;
			}
		}

		return true;
	}

	function formatMessage( template, value ) {
		if ( typeof template !== 'string' ) {
			return String( value );
		}

		// Use a replacer function so special patterns ($&, $$, etc.) in the
		// user-entered value are inserted literally rather than interpreted.
		return template.replace( '%s', function () {
			return value;
		} );
	}

	function clearFieldError( $field ) {
		const $row = $field.closest( '.form-row' );
		const errorId = $field.attr( 'id' ) + '_description';

		$row.removeClass(
			'woocommerce-invalid woocommerce-invalid-required-field woocommerce-invalid-email'
		);
		$row.find( '.aw-referral-inline-error-message' ).remove();
		$field.removeAttr( 'aria-invalid' );

		const describedBy = ( $field.attr( 'aria-describedby' ) || '' )
			.split( /\s+/ )
			.filter( Boolean )
			.filter( ( id ) => id !== errorId );

		if ( describedBy.length ) {
			$field.attr( 'aria-describedby', describedBy.join( ' ' ) );
		} else {
			$field.removeAttr( 'aria-describedby' );
		}
	}

	function clearShareFormErrors( $form ) {
		$form.find( '.aw-referral-form-notices' ).remove();
		$form.find( '.aw-referral-email-field' ).each( function () {
			clearFieldError( $( this ) );
		} );
	}

	function setFieldError( $field, message, errorClass ) {
		const $row = $field.closest( '.form-row' );
		const fieldId = $field.attr( 'id' );
		const errorId = fieldId + '_description';

		clearFieldError( $field );

		$row.addClass( 'woocommerce-invalid ' + errorClass );

		const $error = $( '<p>', {
			id: errorId,
			class: 'aw-referral-inline-error-message',
			text: message,
		} );

		$row.append( $error );
		$field.attr( 'aria-invalid', 'true' );

		const describedBy = ( $field.attr( 'aria-describedby' ) || '' )
			.split( /\s+/ )
			.filter( Boolean );

		if ( ! describedBy.includes( errorId ) ) {
			describedBy.push( errorId );
		}

		$field.attr( 'aria-describedby', describedBy.join( ' ' ) );

		return {
			index: $field.data( 'field-index' ),
			message,
		};
	}

	function showErrorSummary( $form, fieldErrors ) {
		if ( ! fieldErrors.length ) {
			return null;
		}

		const $summary = $( '<div>', {
			id: 'aw-referral-form-errors',
			class: 'woocommerce-NoticeGroup aw-referral-form-notices',
			role: 'alert',
		} );
		const $list = $( '<ul>', {
			class: 'woocommerce-error',
			tabindex: -1,
		} );

		fieldErrors.forEach( function ( fieldError ) {
			const fieldId = 'referral_email_' + fieldError.index;
			const $link = $( '<a>', {
				href: '#' + fieldId,
				text: fieldError.message,
			} );

			$list.append( $( '<li>' ).append( $link ) );
		} );

		$summary.append( $list );
		$form.find( '#aw-referral-form-instructions' ).before( $summary );

		return $summary;
	}

	// Move keyboard/AT focus to the error summary so it is announced and
	// reachable. Scrolling alone does not move focus.
	function focusErrorSummary( $summary ) {
		if ( ! $summary || ! $summary.length ) {
			return;
		}

		const $list = $summary.find( 'ul' );

		if ( ! $list.length ) {
			return;
		}

		$( 'html, body' ).animate(
			{
				scrollTop: $summary.offset().top - 100,
			},
			500,
			function () {
				$list.trigger( 'focus' );
			}
		);
	}

	// True when the field currently satisfies its validation rules.
	function validateField( $field ) {
		const $row = $field.closest( '.form-row' );
		const value = $.trim( $field.val() );

		if ( $row.hasClass( 'validate-required' ) && value === '' ) {
			return false;
		}

		if ( value === '' ) {
			return true;
		}

		return isValidEmail( value );
	}

	function validateShareForm( $form ) {
		clearShareFormErrors( $form );

		const fieldErrors = [];

		$form.find( '.aw-referral-email-field' ).each( function () {
			const $field = $( this );
			const $row = $field.closest( '.form-row' );
			const value = $.trim( $field.val() );

			if ( $row.hasClass( 'validate-required' ) && value === '' ) {
				fieldErrors.push(
					setFieldError(
						$field,
						shareFormI18n.required_field,
						'woocommerce-invalid-required-field'
					)
				);
				return;
			}

			if ( value === '' ) {
				return;
			}

			if ( ! isValidEmail( value ) ) {
				fieldErrors.push(
					setFieldError(
						$field,
						formatMessage( shareFormI18n.invalid_email, value ),
						'woocommerce-invalid-email'
					)
				);
			}
		} );

		if ( fieldErrors.length ) {
			focusErrorSummary( showErrorSummary( $form, fieldErrors ) );

			return false;
		}

		return true;
	}

	const $shareForm = $( '.aw-email-referral-form' );

	if ( $shareForm.length ) {
		$shareForm.on( 'submit', function ( event ) {
			if ( ! validateShareForm( $shareForm ) ) {
				event.preventDefault();
			}
		} );

		$shareForm.on( 'input', '.aw-referral-email-field', function () {
			const $field = $( this );

			// Keep the message until the field is actually corrected, so errors
			// do not vanish mid-edit while the value is still invalid.
			if ( ! validateField( $field ) ) {
				return;
			}

			clearFieldError( $field );

			// Drop only this field's summary link; keep the summary while other
			// fields are still invalid, and remove it once nothing is left.
			const $summary = $shareForm.find( '.aw-referral-form-notices' );

			if ( $summary.length ) {
				$summary
					.find( 'a[href="#' + $field.attr( 'id' ) + '"]' )
					.closest( 'li' )
					.remove();

				if ( ! $summary.find( 'li' ).length ) {
					$summary.remove();
				}
			}
		} );

		// After a server-side validation failure the summary is rendered on
		// page load; move focus to it so it is announced and reachable.
		focusErrorSummary( $shareForm.find( '.aw-referral-form-notices' ) );
	}
} );
